import {afterDomBuilt, searchOrFallback} from "./globals.ts";

const bingCacheKey = 'wallpaper_cache_v1'
const defaultWallpaperApi = 'https://bing.biturl.top/?resolution=1920&format=json&index=0&mkt=zh-CN'

type TimeoutAbleJsonFetcher = <T> (uri: string | URL, options: RequestInit, timeout: number, fallback: () => T) => Promise<T>

const timeoutSignalConstructor: ((millis: number) => AbortSignal) = AbortSignal.timeout || function (millis) {
    const controller = new AbortController()
    setTimeout(() => controller.abort(new DOMException(`signal timed out after ${millis} ms`, 'TimeoutError')), millis)
    return controller.signal
}

const fetchJsonWithTimeout: TimeoutAbleJsonFetcher = async function <T> (uri: string | URL, options: RequestInit, timeout: number, fallback: () => T): Promise<T> {
    try {
        const response = await fetch(uri, {
            ...options,
            signal: timeoutSignalConstructor(timeout)
        })
        if (!response.ok) return fallback()
        return response.json()
    } catch (e) {
        console.error('Error while fetching wallpaper data', e)
        return fallback()
    }
}

async function loadWallpaperApi() {
    const wallpaperApiUrl = searchOrFallback('wallpaper-api', defaultWallpaperApi)
    let wallpaperApiCached: any
    try {
        wallpaperApiCached = JSON.parse(localStorage.getItem(bingCacheKey) || '{}')
        if (typeof wallpaperApiCached !== 'object' || wallpaperApiCached === null) {
            wallpaperApiCached = {}
        }
    } catch {
        wallpaperApiCached = {}
    }

    // Always update, fallback to cached
    const wallpaperApi = await fetchJsonWithTimeout(wallpaperApiUrl, {}, 3000, () => wallpaperApiCached)
    const wallpaperUrl: unknown = wallpaperApi.url
    if (typeof wallpaperUrl === 'string') {
        const style: CSSStyleDeclaration = document.body.style
        // use JSON.stringify to add double quotes safely
        style.backgroundImage = `url(${JSON.stringify(new URL(wallpaperUrl, 'https://www.bing.com'))})`
        style.backgroundRepeat = 'no-repeat'
        style.backgroundPosition = 'center center'
        style.backgroundAttachment = 'fixed'
        style.backgroundSize = 'cover'

        localStorage.setItem(bingCacheKey, JSON.stringify(wallpaperApi))
    }
}

afterDomBuilt(loadWallpaperApi)
